<template>
    <section class="text-center max-w-xl mx-auto pt-12">
        <BackButton :to="{ name: 'home' }" />
        <Title>Loups Garous</Title>
        <div class="space-y-6 pt-8 pb-5">
            <button v-if="GameStarted" class="w-full bg-gradient-to-r from-blue-400 to-blue-500 text-white font-bold py-4 px-4 rounded"
                @click="$router.push({ name: 'loups-garous-play' })">
                Continuer la partie
            </button>
            <h1 class="text-xl">Rôles</h1>
            <div class="grid grid-cols-2 gap-y-2">
                <ToggleSwitch v-for="role in Roles" :key="role" :label="role" v-model="AllowedRoles[role]" />
            </div>
            <Counter label="Nombre de loups garous" v-model="NumberOfWerewolves" />
            <div class="mb-4">
                <h1 class="text-xl">Joueurs</h1>
                <p class="text-sm text-left">{{Players.length}} joueurs</p>
                <div class="flex mt-4">
                    <input class="shadow appearance-none border rounded w-full py-2 px-3 mr-4 bg-gray-800 border-gray-600 text-gray-200" placeholder="Ajouter un joueur" v-model="name">
                    <button class="flex-no-shrink p-2 border-2 rounded border-gray-200 text-gray-200"
                        @click="AddPlayer(name), name=''">Ajouter</button>
                </div>
            </div>
            <div>
                <div class="flex mb-4 items-center text-left" v-for="(joueur, index) in Players" :key="joueur.name">
                    <p class="w-full text-gray-200">{{joueur.name}}</p>
                    <button class="flex-no-shrink p-2 ml-2 border-2 border-red-300 text-red-300 rounded"
                        @click="RemovePlayer(index)">Retirer</button>
                </div>
            </div>
            <button class="w-full bg-gradient-to-r from-violet-400 to-violet-500 text-white font-bold py-4 px-4 rounded"
                @click="handleStart">
                Démarrer une nouvelle partie
            </button>
            
        </div>
    </section>
</template>
<script>
import { mapModels, mapFields } from '@/models'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
    data: function () {
        return {
            name: ''
        }
    },
    computed: {
        ...mapFields('LoupsGarous', ['AllowedRoles', 'NumberOfWerewolves']),
        ...mapModels(['Roles']),
        ...mapState('LoupsGarous', ['Players', 'GameStarted'])
    },
    methods: {
        ...mapMutations('LoupsGarous', ['AddPlayer', 'RemovePlayer']),
        ...mapActions('LoupsGarous', ['StartGame']),
        handleStart() {
            try {
                this.StartGame()     
                this.$router.push({ name: 'loups-garous-play' })
            }
            catch(err) {
                this.$toasted.error(err)
            }
        }
    }
}
</script>